<template>
    <div class="Information">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Basic Info</h4>
                        <p>
                            <span class="bold">Family Name: </span>
                            <StringEditor v-bind:old-value="RecordData.Name"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Family Name"
                                          property-name="Name"
                                          update-method="StrongFamilies/VolunteerFamilies"
                                          v-bind:required="true"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Territory: </span>
                            <SelectEditor v-bind:old-value="RecordData.SubProgramTerritoryID"
                                          v-bind:old-value-text="RecordData.SubProgramTerritory.Name"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Territory"
                                          property-name="SubProgramTerritoryID"
                                          update-method="StrongFamilies/VolunteerFamilies"
                                          required="true"
                                          :options="SubProgramTerritoryOptions"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Family Phone (from Inquiry): </span>
                            <StringEditor v-bind:old-value="NotificationPhone"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Notification Phone"
                                          property-name="NotificationPhone"
                                          update-method="StrongFamilies/VolunteerFamilies"
                                          v-bind:required="false"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Family Email (from Inquiry): </span>
                            <StringEditor v-bind:old-value="RecordData.SFEmail"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Notification Email"
                                          property-name="SFEmail"
                                          update-method="StrongFamilies/VolunteerFamilies"
                                          v-bind:required="false"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                    </div>
                </div>

                <div class="col col-md-4">
                    <div class="record-section">
                        <h4>Physical Address</h4>
                        <AddressEditor v-bind:old-value="PhysicalAddress"
                                       v-bind:record-id="PhysicalAddress.Id"
                                       v-bind:edit-mode="EditMode"
                                       data-label="Physical Address"
                                       update-method="Core/Address/Update"
                                       required="true" />
                    </div>

                </div>
                <div class="col col-md-4">
                    <div class="record-section">
                        <h4>Mailing Address</h4>
                        <AddressEditor v-bind:old-value="MailingAddress"
                                       v-bind:record-id="MailingAddress.Id"
                                       v-bind:edit-mode="EditMode"
                                       data-label="Mailing Address"
                                       update-method="Core/Address/Update"
                                       required="false" />
                    </div>

                </div>
                <div class="col col-md-4">
                    <div class="record-section">
                        <h4>Controls</h4>
                        <p>
                            <span class="bold">Status: </span>
                            <SelectEditor v-bind:old-value="RecordData.MainStatus"
                                          v-bind:old-value-text="RecordData.MainStatus"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Approval Status"
                                          property-name="MainStatus"
                                          update-method="StrongFamilies/VolunteerFamilies"
                                          required="true"
                                          :options="ApprovalStatuses"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                        <!--<h4>Contact Preferences</h4>
                        <p>
                            <span class="bold">Text Preference: </span>
                            <SelectEditor v-bind:old-value="RecordData.IsTextMessageOK"
                                          v-bind:old-value-text="RecordData.IsTextMessageOK ? 'Yes' : 'No'"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Text Preference"
                                          property-name="IsTextMessageOK"
                                          update-method="StrongFamilies/VolunteerFamilies"
                                          required="true"
                                          :options="YesNoOptions"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Email Preference: </span>
                            <SelectEditor v-bind:old-value="RecordData.IsEmailMessageOK"
                                          v-bind:old-value-text="RecordData.IsEmailMessageOK ? 'Yes' : 'No'"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Email Preference"
                                          property-name="IsEmailMessageOK"
                                          update-method="StrongFamilies/VolunteerFamilies"
                                          required="true"
                                          :options="YesNoOptions"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Mail Preference: </span>
                            <SelectEditor v-bind:old-value="RecordData.IsMailOK"
                                          v-bind:old-value-text="RecordData.IsMailOK ? 'Yes' : 'No'"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Mail Preference"
                                          property-name="IsMailOK"
                                          update-method="StrongFamilies/VolunteerFamilies"
                                          required="true"
                                          :options="YesNoOptions"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>-->
                        <h4>Family Type</h4>
                        <p>
                            <span class="bold">Host Family: </span>
                            <SelectEditor v-bind:old-value="RecordData.IsMailOK"
                                          v-bind:old-value-text="RecordData.IsHost ? 'Yes' : 'No'"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Host Family"
                                          property-name="IsHost"
                                          update-method="StrongFamilies/VolunteerFamilies"
                                          required="true"
                                          :options="YesNoOptions"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Family Friend: </span>
                            <SelectEditor v-bind:old-value="RecordData.IsFriend"
                                          v-bind:old-value-text="RecordData.IsFriend ? 'Yes' : 'No'"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Family Friend"
                                          property-name="IsFriend"
                                          update-method="StrongFamilies/VolunteerFamilies"
                                          required="true"
                                          :options="YesNoOptions"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Champion: </span>
                            <SelectEditor v-bind:old-value="RecordData.IsChampion"
                                          v-bind:old-value-text="RecordData.IsChampion ? 'Yes' : 'No'"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Champion"
                                          property-name="IsChampion"
                                          update-method="StrongFamilies/VolunteerFamilies"
                                          required="true"
                                          :options="YesNoOptions"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id" />
                        </p>
                    </div>
                </div>
                <div class="col col-md-4">
                    <div class="record-section">
                        <h4>Associations</h4>
                        <p>
                            <span class="bold">Church Attending: </span>
                            <SelectEditor v-bind:old-value="GetChurchMembershipOfType('Church Attended').Church.Id"
                                          v-bind:old-value-text="GetChurchMembershipOfType('Church Attended').Church.Name"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Church Attending"
                                          property-name="ChurchID"
                                          update-method="StrongFamilies/VolunteerFamilies/ChurchMembership"
                                          :required="false"
                                          :options="AvailableChurches"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id"
                                          :chart-update-only="true"
                                          :additional-payload="{FamilyID: RecordData.Id, MembershipType: 'Church Attended'}" />
                        </p>
                        <p>
                            <span class="bold">Hosting Support Church: </span>
                            <SelectEditor v-bind:old-value="GetChurchMembershipOfType('Strong Families Church').Church.Id"
                                          v-bind:old-value-text="GetChurchMembershipOfType('Strong Families Church').Church.Name"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Hosting Support Church"
                                          property-name="ChurchID"
                                          update-method="StrongFamilies/VolunteerFamilies/ChurchMembership"
                                          :required="false"
                                          :options="AvailableChurches"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id"
                                          :chart-update-only="true"
                                          :additional-payload="{FamilyID: RecordData.Id, MembershipType: 'Strong Families Church'}" />
                        </p>
                    </div>
                </div>
                <div class="col col-md-4">
                    <div class="record-section">
                        <h4>Additional Info</h4>
                        
                        <p>
                            <span class="bold">Special Skills: </span>
                            <CheckboxEditor v-bind:old-value="RecordData.SpecialSkills"
                                          v-bind:old-value-text="RecordData.SpecialSkills"
                                          v-bind:record-id="RecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Special Skills"
                                          property-name="SpecialSkills"
                                          update-method="StrongFamilies/VolunteerFamilies"
                                          :required="false"
                                          :options="SpecialSkillsOptions"
                                          http-method="PATCH"
                                          :chart-id="RecordData.Id"
                                          :chart-update-only="true"
                                          :additional-payload="{}" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
        
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" permission=""/>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import StringEditor from '../../../../Core/ItemEditors/StringEditor';
    import DateEditor from '../../../../Core/ItemEditors/DateEditor';
    import SelectEditor from '../../../../Core/ItemEditors/SelectEditor';
    import CheckboxEditor from '../../../../Core/ItemEditors/CheckboxEditor';
    import PersonEditor from '../../../../Core/ItemEditors/PersonEditor';
    import EditMode from '../../../../Core/ItemEditors/EditMode.vue';
    import AddressEditor from '../../../../Core/ItemEditors/AddressEditor.vue';
    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                EditMode: false,
                ApprovalStatuses: [
                    {
                        text: "Approved",
                        value: "Approved"
                    },
                    {
                        text: "Coordinator",
                        value: "Coordinator"
                    },
                    {
                        text: "In Training",
                        value: "In Training"
                    },
                    {
                        text: "No App Form",
                        value: "No App Form"
                    },
                    {
                        text: "No Roles",
                        value: "No Roles"
                    },
                    {
                        text: "On Hold",
                        value: "On Hold"
                    },
                    {
                        text: "RF Exclusive",
                        value: "RF Exclusive"
                    },
                    {
                        text: "Switched Off",
                        value: "Switched Off"
                    }
                ],
                SpecialSkillsOptions: [
                    {
                        text: "ADD/ADHD",
                        value: "ADD/ADHD"
                    },
                    {
                        text: "Autism",
                        value: "Autism"
                    },
                    {
                        text: "Cerebral Palsy",
                        value: "Cerebral Palsy"
                    },
                    {
                        text: "Dealing with Difficult Teens",
                        value: "Dealing with Difficult Teens"
                    },
                    {
                        text: "Diabetes",
                        value: "Diabetes"
                    },
                    {
                        text: "Dietary Restrictions",
                        value: "Dietary Restrictions"
                    },
                    {
                        text: "Eating Disorders",
                        value: "Eating Disorders"
                    },
                    {
                        text: "Feeding Tube",
                        value: "Feeding Tube"
                    },
                    {
                        text: "House Wheelchair Accessible",
                        value: "House Wheelchair Accessible"
                    },
                    {
                        text: "Newborns",
                        value: "Newborns"
                    },
                    {
                        text: "Other Languages",
                        value: "Other Languages"
                    },
                    {
                        text: "Quadriplegic",
                        value: "Quadriplegic"
                    },
                    {
                        text: "Teen Moms",
                        value: "Teen Moms"
                    }
                ],
                YesNoOptions: [
                    {
                        text: "Yes",
                        value: true
                    },
                    {
                        text: "No",
                        value: false
                    },
                ]
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
            GetChurchMembershipOfType(membershipType) {
                let matches = this.RecordData.Churches.filter(c => c.MembershipType == membershipType);
                if (matches.length == 1) {
                    return matches[0];
                } else {
                    return {
                        Church: {
                            Name: "",
                            Id: null
                        }
                    }
                }
            },
            
        },
        components: {
            StringEditor,
            DateEditor,
            SelectEditor,
            CheckboxEditor,
            PersonEditor,
            EditMode,
            AddressEditor
        },
        mounted() {

        },
        computed: {
            SubProgramTerritoryOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramTerritoryOptions"]();
            },
            AvailableChurches: function () {
                let options = [
                    {
                        text: "",
                        value: null
                    }
                ]
                return options.concat(this.$store.getters["Churches.ChurchOptions"]());
            },
            PhysicalAddress: function () {
                let physicalAddresses = this.RecordData.AddressMemberships.filter(am => am.Address.Type == "Physical");
                if (physicalAddresses.length > 0) {
                    return physicalAddresses[0].Address;
                } else {
                    return null;
                }
            },
            MailingAddress: function () {
                let physicalAddresses = this.RecordData.AddressMemberships.filter(am => am.Address.Type == "Mailing");
                if (physicalAddresses.length > 0) {
                    return physicalAddresses[0].Address;
                } else {
                    return null;
                }
            },
            NotificationPhone: function () {
                if (this.RecordData.SFPhoneNumber) {
                    return this.RecordData.SFPhoneNumber.PhoneNumberDigits;
                } else {
                    return "";
                }
            }
        }
    }
</script>

<style scoped>
</style>